
import React from "react";
import { motion } from "framer-motion";
import devSvg from "../assets/undraw_web-developer_ggt0.svg";

function Hero() {
  return (
    <section
      id="hero"
      className="relative flex flex-col-reverse md:flex-row items-center justify-center min-h-[80vh] md:min-h-screen px-4 py-10 md:py-0 bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 overflow-hidden"
    >
      {/* Left: Text */}
      <div className="z-10 flex flex-col items-center flex-1 md:items-start">
        <motion.h1
          className="text-4xl font-extrabold text-center text-transparent sm:text-5xl md:text-6xl md:text-left bg-gradient-to-r from-teal-400 via-blue-400 to-purple-500 bg-clip-text drop-shadow-lg animate-gradient-move"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Hi, I'm M. Shaheer Haider <span className="inline-block">👋</span>
        </motion.h1>
        <motion.p
          className="max-w-xl mt-4 text-base text-center text-gray-200 sm:text-lg md:text-xl md:text-left"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          A Frontend Developer skilled in <span className="font-semibold text-teal-400">React</span>, <span className="font-semibold text-yellow-400">Firebase</span>, <span className="font-semibold text-purple-400">Redux</span>, and <span className="font-semibold text-blue-400">Tailwind CSS</span>.
        </motion.p>
        <motion.div
          className="flex gap-4 pt-8"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 0.8 }}
        >
          <motion.button
            type="button"
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.96 }}
            className="inline-block px-8 py-3 font-bold text-white transition-all duration-300 rounded-full shadow-lg bg-gradient-to-r from-teal-500 to-blue-500 hover:from-blue-500 hover:to-teal-500 focus:outline-none focus:ring-4 focus:ring-teal-400/50"
            onClick={() => {
              const el = document.getElementById('projects');
              if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
          >
            View Projects
          </motion.button>
          <motion.button
            type="button"
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.96 }}
            className="inline-block px-8 py-3 font-bold text-teal-400 transition-all duration-300 border-2 border-teal-400 rounded-full shadow-lg hover:bg-teal-400 hover:text-gray-900 focus:outline-none focus:ring-4 focus:ring-teal-400/50"
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
          >
            Contact Me
          </motion.button>
        </motion.div>
      </div>
      {/* Right: SVG Illustration */}
      <motion.div
        className="z-0 flex items-center justify-center flex-1 mb-8 md:mb-0"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.7, duration: 1 }}
      >
        <img
          src={devSvg}
          alt="Web Developer Illustration"
          className="w-64 sm:w-80 md:w-[28rem] max-w-full drop-shadow-2xl animate-float"
          loading="lazy"
        />
      </motion.div>
      {/* Animated background blobs */}
      <div className="absolute bg-teal-500 rounded-full -top-20 -left-20 w-72 h-72 opacity-20 filter blur-3xl animate-blob1" />
      <div className="absolute bg-purple-500 rounded-full -bottom-24 -right-24 w-96 h-96 opacity-20 filter blur-3xl animate-blob2" />
    </section>
  );
}

export default Hero;
